import keyMirror from 'key-mirror';

export default keyMirror({
  ADMIN: null,
  CARE_AUTHOR: null,
  CARE_NAVIGATOR: null,
  PATIENT: null,
  FIRST_RESPONDER: null
});
